import { productList } from "constants/product";

const initialState = {
  productList: {},
};

const products = (state = initialState, action) => {
  switch (action.type) {
    case productList:
      return { ...state, productList: action.payload };
    default:
      return state;
  }
};

export default products;